import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PageWrapper from './components/PageWrapper';
import Home from './routes/Home';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Brands from "./routes/Brands";
import Events from "./routes/Events";
import Gallery from "./routes/Gallery";
import Press from "./routes/Press";
import About from "./routes/About";
import ViewPress from "./routes/ViewPress";
import Contact from "./routes/Contact";

// Custom hook to scroll to top on route changes
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/brands" element={<PageWrapper><Brands /></PageWrapper>} />
        <Route path="/events" element={<PageWrapper><Events /></PageWrapper>} />
        <Route path="/gallery" element={<PageWrapper><Gallery /></PageWrapper>} />
        <Route path="/press" element={<PageWrapper><Press /></PageWrapper>} />
        <Route path="/about" element={<PageWrapper><About /></PageWrapper>} />
        <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} />
        <Route path="/press/view" element={<PageWrapper><ViewPress /></PageWrapper>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
